<div class="div-header-content">
  <header class="header-full">
    <img class="img-logo" (click)="navigate('invoice')" src="assets/images/rbsFavicon.png">
    <nav>
      <ul class="test">
        <li *ngIf="getApplicationRoles().includes('APP_UserAdmin')"><button mat-button  class="navbar-buttons" (click)="navigate('admin')" color="accent">Admin</button></li>
        <li *ngIf="getUserRoles().includes('Invoice Approver')"><button mat-button  class="navbar-buttons" (click)="navigate('invoice')" color="accent">Invoice</button></li>
        <li *ngIf="getUserRoles().includes('Invoice Approver')"><button mat-button  class="navbar-buttons" (click)="navigate('invoice-approved')" color="accent">Approved Inv.</button></li>
        <li *ngIf="getUserRoles().includes('Invoice Approver')"><button mat-button  class="navbar-buttons" (click)="navigate('substitute-settings')" color="accent">Stellvertreter</button></li>
        <li *ngIf="getUserRoles().includes('Invoice Manager')"><button mat-button  class="navbar-buttons" (click)="navigate('invoice-management')" color="accent">Invoice Mgmt.</button></li>
        <li *ngIf="getUserRoles().includes('Invoice History')"><button mat-button  class="navbar-buttons" (click)="navigate('invoice-history')" color="accent">Invoice History</button></li>
      </ul>
    <div class="div-user-information">
      <!-- <span *ngIf="currentUser" [matTooltip]="currentUser.email||'...'">{{currentUser.firstname}} {{currentUser.lastname}}</span>
      <button mat-button color="accent" (click)="logout()">Abmelden</button> -->

      <div *ngIf="currentUser" class="div-user-information-email" [matTooltip]="currentUser.email||'...'">
        {{currentUser.firstname}} {{currentUser.lastname}} 
      </div>
      <div class="div-user-information-logout" (click)="logout()">
        Abmelden
      </div>
    </div>
  </nav>
  </header>
  
  <div id="hamburger-icon" (click)="toggleMobileMenu(this)">
    <div class="bar1"></div>
    <div class="bar2"></div>
    <div class="bar3"></div>
    <ul class="mobile-menu">
      <li><a mat-button *ngIf="getApplicationRoles().includes('APP_UserAdmin')" (click)="navigate('admin')"
             color="accent">Admin</a></li>
      <li><a mat-button *ngIf="getUserRoles().includes('Invoice Approver')" (click)="navigate('invoice')"
             color="accent">Invoice</a></li>
      <li><a mat-button *ngIf="getUserRoles().includes('Invoice Approver')" (click)="navigate('invoice-approved')"
             color="accent">Approved Inv.</a></li>
      <li><a mat-button *ngIf="getUserRoles().includes('Invoice Approver')" (click)="navigate('substitute-settings')"
             color="accent">Stellvertreter</a></li>
      <li><a mat-button *ngIf="getUserRoles().includes('Invoice Manager')" (click)="navigate('invoice-management')"
             color="accent">Invoice Mgmt.</a></li>
      <li><a mat-button *ngIf="getUserRoles().includes('Invoice History')" (click)="navigate('invoice-history')"
             color="accent">Invoice History</a></li>
      <li>
        <div class="div-user-information">
          <div *ngIf="currentUser" class="div-user-information-email" [matTooltip]="currentUser.email||'...'">
            {{currentUser.firstname}} {{currentUser.lastname}}
          </div>
          <div class="div-user-information-logout" (click)="logout()">
            Abmelden
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
